import { render, staticRenderFns } from "./DevAxFormField.vue?vue&type=template&id=5f4fcac1&scoped=true&"
import script from "./DevAxFormField.vue?vue&type=script&lang=ts&"
export * from "./DevAxFormField.vue?vue&type=script&lang=ts&"
import style0 from "./DevAxFormField.vue?vue&type=style&index=0&id=5f4fcac1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4fcac1",
  null
  
)

export default component.exports